import Vue from "vue";
import Router from "vue-router";
import Main from "@/components/funplus/Main.vue";
import Browse from "@/components/funplus/Browse.vue";
import Profile from "@/components/funplus/Profile.vue";
import HotPicks from "@/components/funplus/HotPicks.vue";
import Popular from "@/components/funplus/Popular.vue";
import Category from "@/components/funplus/browse/Category.vue";
import Subcategory from "@/components/funplus/browse/Subcategory.vue";
import DetailPage from "@/components/funplus/DetailPage.vue";
import Login from "../components/authentication/funplus/Login.vue";
import Contact from "../components/funplus/Contact.vue";
import Feedback from "../components/funplus/Feedback.vue";
import PrivacyPolicy from "../components/funplus/PrivacyPolicy.vue";
import Faq from "../components/funplus/Faq.vue";
import Unsubscription from "../components/funplus/Unsubscription.vue";
import Terms from "../components/funplus/Terms.vue";
Vue.use(Router);

export default new Router({
  mode: "history",
  hash: false,
  history: true,
  routes: [
    {
      path: "/home",
      name: "Main",
      component: Main,
      children: [
        {
          path: "/home/:token"
        }
      ]
    },
    {
      path: "/login",
      name: "Login",
      component: Login,
      children: [
        {
          path: "/logout"
        }
      ]
    },
    {
      path: "/browse",
      name: "Browse",
      component: Browse,
      children: [
        {
          path: "/browse/:token"
        }
      ]
    },
    {
      path: "/hotpicks",
      name: "HotPicks",
      component: HotPicks,
      children: [
        {
          path: "/hotpicks/:token"
        }
      ]
    },
    {
      path: "/popular",
      name: "Popular",
      component: Popular,
      children: [
        {
          path: "/popular/:token"
        }
      ]
    },
    {
      path: "/terms",
      name: "Terms",
      component: Terms,
      children: [
        {
          path: "/terms/:token"
        }
      ]
    },
    {
      path: "/contact",
      name: "Contact",
      component: Contact,
      children: [
        {
          path: "/contact/:token"
        }
      ]
    },
    {
      path: "/faq",
      name: "Faq",
      component: Faq,
      children: [
        {
          path: "/faq/:token"
        }
      ]
    },
    {
      path: "/feedback",
      name: "Feedback",
      component: Feedback,
      children: [
        {
          path: "/feedback/:token"
        }
      ]
    },
    {
      path: "/privacy",
      name: "PrivacyPolicy",
      component: PrivacyPolicy,
      children: [
        {
          path: "/privacy/:token"
        }
      ]
    },
    {
      path: "/profile",
      name: "Profile",
      component: Profile,
      children: [
        {
          path: "/profile/:token"
        }
      ]
    },
    {
      path: "/detail/:id",
      name: "DetailPage",
      component: DetailPage,
      children: [
        {
          path: "/detail/:id/:token"
        }
      ]
    },
    {
      path: "/subcategory/:category/:subcat",
      name: "Subcategory",
      component: Subcategory,
      children: [
        {
          path: "/subcategory/:category/:subcat/:token"
        }
      ]
    },
    {
      path: "/category/:category",
      name: "Category",
      component: Category,
      children: [
        {
          path: "/category/:category/:token"
        }
      ]
    },
    {
      path: "/unsubscription",
      name: "Unsubscription",
      component: Unsubscription,
    },
    {
      path: '/:token',
      name: 'Main',
      component: Main
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/funplus.js